var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.85491 12.6409C0.85491 15.5962 2.02889 18.4304 4.11858 20.5201C6.20827 22.6098 9.0425 23.7838 11.9978 23.7838C14.953 23.7838 17.7873 22.6098 19.877 20.5201C21.9666 18.4304 23.1406 15.5962 23.1406 12.6409M0.85491 12.6409C0.85491 9.68563 2.02889 6.85141 4.11858 4.76171C6.20827 2.67202 9.0425 1.49805 11.9978 1.49805C14.953 1.49805 17.7873 2.67202 19.877 4.76171C21.9666 6.85141 23.1406 9.68563 23.1406 12.6409M0.85491 12.6409H23.1406",
    stroke: "#EE3224",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70982 12.6409C7.92033 16.7157 9.42123 20.6181 11.9955 23.7838C14.5698 20.6181 16.0707 16.7157 16.2812 12.6409C16.0707 8.56606 14.5698 4.66374 11.9955 1.49805C9.42123 4.66374 7.92033 8.56606 7.70982 12.6409Z",
    stroke: "#EE3224",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/Website.e1c1291aad1f643917dd0381c6430745.svg";
export { ForwardRef as ReactComponent };